// extracted by mini-css-extract-plugin
export default {"aboutUsDescription":"value_aboutUsDescription__Gs2FX","headings":"value_headings__ays29","paragraphPC":"value_paragraphPC__Hry29","paragraphMobile":"value_paragraphMobile__iWR-J"};